// WeekStrip.js
// "This week" card: a learning-days ring plus minutes/quizzes/accuracy stats.
// See docs/superpowers/specs/2026-09-16-home-redesign.md §5 (Student > WeekStrip).
import React from "react";
import { View, StyleSheet } from "react-native";

import HomeCard from "../primitives/HomeCard";
import HomeRing from "../primitives/HomeRing";
import HomeStat from "../primitives/HomeStat";
import { formatWeekTime } from "../homeTime";

const WeekStrip = ({ week, isDarkMode = false, t = (s) => s }) => {
  const learningDays = week?.learningDays ?? 0;
  const goalDays = week?.goalDays ?? 0;
  const minutes = week?.minutes ?? 0;
  const timeStat = formatWeekTime(minutes, t);
  const quizzes = week?.quizzes ?? 0;
  const accuracy = week?.accuracy ?? null;

  const remaining = goalDays - learningDays;
  const goalMet = remaining <= 0;
  const sublabel = goalMet ? t("Goal met") : t("{count} more to hit it", { count: remaining });

  return (
    <HomeCard title={t("This week")} isDarkMode={isDarkMode} testID="week-strip">
      <HomeRing
        value={learningDays}
        max={goalDays}
        label={t("Learning days")}
        sublabel={sublabel}
        sublabelTone={goalMet ? "ok" : undefined}
        isDarkMode={isDarkMode}
        testID="week-strip-ring"
      />
      <View style={styles.statsRow}>
        <HomeStat value={timeStat.value} label={timeStat.label} isDarkMode={isDarkMode} />
        <HomeStat value={quizzes} label={t("Quizzes")} isDarkMode={isDarkMode} />
        {accuracy != null ? (
          <HomeStat value={`${Math.round(accuracy * 100)}%`} label={t("Accuracy")} isDarkMode={isDarkMode} />
        ) : null}
      </View>
    </HomeCard>
  );
};

const styles = StyleSheet.create({
  statsRow: {
    flexDirection: "row",
    gap: 20,
    marginTop: 14,
  },
});

export default WeekStrip;
